import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Typography, Box, TextField, MenuItem, Checkbox, FormControlLabel, IconButton } from '@mui/material';
import React, { useContext } from 'react';
import navbar_background from '../assets/navbar_background.svg';
import useApiRequest from '../services/apiRequest';
import endpoints from '../constants/endpoints';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import { Close } from '@mui/icons-material';

type Props = {
    open: boolean,
    onClose: (() => void)
}

function NewUserDialog({ open, onClose }: Props) {
    const { get, post, put, remove, downloadFile } = useApiRequest();
    const { userPermissions } = useContext(GlobalStateContext);
    const [userName, setUserName] = React.useState<string>('');
    const [userType, setUserType] = React.useState<string>('');
    const [get_aggregate, set_get_aggregate] = React.useState<boolean>(true);
    const [print_list_items, set_print_list_items] = React.useState<boolean>(true);
    const [generate_file, set_generate_file] = React.useState<boolean>(true);
    const [get_file, set_get_file] = React.useState<boolean>(true);
    const [delete_file, set_delete_file] = React.useState<boolean>(true);
    const { currentUser, setCurrentUser } = React.useContext(GlobalStateContext);

    const handleCreate = async () => {

        if (userName != '' && userType != '') {
            const body = {
                "usuario": userName,
                "type": userType,
                "see_logs_user": true,
                "see_logs_admin": true,
                "create_user": true,
                "create_admin": true,
                "print_list_items": print_list_items,
                "generate_file": generate_file,
                "get_file": get_file,
                "delete_file": delete_file,
                "get_aggregate": get_aggregate
            }

            await post(`${endpoints.CREATE_EDIT_USER}/${currentUser?.profile.username}`, body).then(() => { cleanFields(); onClose() });
        }

    }

    const cleanFields = () => {
        setUserName('');
        setUserType('');
        set_get_aggregate(true);
        set_print_list_items(true);
        set_generate_file(true);
        set_get_file(true);
        set_delete_file(true);
    }


    return (<Dialog
        open={open}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth='sm'
    >
        <DialogTitle color='white' sx={{ bgcolor: '#00617b', backgroundImage: `url(${navbar_background})`, backgroundSize: "cover" }}>
            <Typography variant="h4">Criar Usuário</Typography>
            <IconButton
                aria-label="close"
                onClick={() => {onClose(); cleanFields();}}
                sx={{
                    position: 'absolute',
                    right: 15,
                    top: 15,
                }}
            >
                <Close sx={{ color: "white" }} />
            </IconButton>
        </DialogTitle>
        <DialogContent sx={{ textAlign: 'center', m: 4 }}>
            <TextField required value={userName} onChange={(ev) => { setUserName(ev.target.value) }} id="outlined-basic" label="Usuário" variant="outlined" fullWidth sx={{ mb: 1, mt: 2 }} />
            <TextField
                required
                id="outlined-select-currency"
                select
                label="Nível"
                value={userType}
                onChange={(ev) => { setUserType(ev.target.value) }}
                fullWidth
            >
                <MenuItem value={'user'}>Usuário</MenuItem>
                <MenuItem value={'admin'}>Administrador</MenuItem>
                {userPermissions.type == 'super admin' && <MenuItem value={'super admin'}>Super Administrador</MenuItem>}
            </TextField>

            <Box sx={{ m: 2 }}>
                <FormControlLabel control={
                    <Checkbox
                        checked={get_aggregate}
                        onChange={(ev) => { set_get_aggregate(ev.target.checked) }}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />

                } label="Calcular sobrepreço" />

                <FormControlLabel control={
                    <Checkbox
                        checked={print_list_items}
                        onChange={(ev) => { set_print_list_items(ev.target.checked) }}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />

                } label="Fazer busca" />

                <FormControlLabel control={
                    <Checkbox
                        checked={generate_file}
                        onChange={(ev) => { set_generate_file(ev.target.checked) }}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />

                } label="Gerar arquivo" />

                <FormControlLabel control={
                    <Checkbox
                        checked={get_file}
                        onChange={(ev) => { set_get_file(ev.target.checked) }}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />

                } label="Baixar arquivo" />

                <FormControlLabel control={
                    <Checkbox
                        checked={delete_file}
                        onChange={(ev) => { set_delete_file(ev.target.checked) }}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />

                } label="Apagar arquivo" />
            </Box>


        </DialogContent>
        <DialogActions>
            <Button onClick={handleCreate} variant='contained'>Aplicar</Button>
        </DialogActions>
    </Dialog>);
}

export default NewUserDialog;
